"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SalesByCategorySummary_1 = __importDefault(require("../entity/SalesByCategorySummary"));
const CategoryStub_1 = __importDefault(require("./CategoryStub"));
class SalesByCategorySummaryStub extends SalesByCategorySummary_1.default {
    constructor({ category = new CategoryStub_1.default(), value = 1000000 } = {}) {
        super({
            category,
            value,
        });
    }
}
exports.default = SalesByCategorySummaryStub;
